import type { GalleryItem } from './types';

export function getImageUrl(item: GalleryItem): string {
  return item.cloudfrontUrl || item.imageUrl || '';
}

export function getAspectRatioClass(aspectRatio: string): string {
  switch (aspectRatio) {
    case 'square':
      return 'aspect-square';
    case '16:9':
      return 'aspect-video';
    case '4:3':
      return 'aspect-[4/3]';
    default:
      return '';
  }
}

export function sortItems(items: GalleryItem[]): GalleryItem[] {
  return [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function filterItemsByCategory(
  items: GalleryItem[],
  activeFilter: string,
  filteringEnabled: boolean
): GalleryItem[] {
  if (filteringEnabled && activeFilter !== 'All') {
    return items.filter(item => item.category === activeFilter || !item.category);
  }
  return items;
}

export function getUniqueCategories(items: GalleryItem[]): string[] {
  return Array.from(new Set(items.map(item => item.category).filter(Boolean))) as string[];
}
